import { render } from "./ApiClientKeyRevealModal.vue?vue&type=template&id=ba8114aa&ts=true"
import script from "./ApiClientKeyRevealModal.vue?vue&type=script&lang=ts"
export * from "./ApiClientKeyRevealModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__